<template>
  <span class="opc-v-loader">
    <zm-spinners v-if="loading" size="sm" type="circle" />
    <span v-else class="opc-v-loader__value">{{ value }}</span>
  </span>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    value: String,
  },
};
</script>

<style lang="scss" scoped>
.opc-v-loader {
  ::v-deep(.zbo-spinners){
    vertical-align: text-top;
  }
}
</style>
